import { CommonModule } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { toBase64 } from "~app/common/utils/file-utils";

function transformAccept(value: string | string[]) {
    if(Array.isArray(value)) {
        return value.join(",");
    }
    return value;
}

function transformMultiple(value: boolean) {

    return value ? "multiple": null;
}

export type FileBase64 = {
    name: string;
    content: string;
    size: number;
};

@Component({
    selector: "rask-file-upload",
    imports: [CommonModule],
    templateUrl: "./file-upload.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./file-upload.component.scss"
})
export class FileUploadComponent {
    @Input() containerClass = "";
    @Input() disabled = false;
    @Input({ transform: transformMultiple }) multiple: string = null;
    @Input({ transform: transformAccept }) accept: string = null;
    @Output() fileChange = new EventEmitter();

    files: FileBase64[] = [];

    async onFileChange(target: HTMLInputElement) {
        const promises = Array.from(target.files)
            .map(this.mapFile);
        this.files = await Promise.all(promises);
        this.fileChange.emit();
        target.value = "";
    }

    private async mapFile(file: File): Promise<FileBase64> {
        return {
            name: file.name,
            content:  await toBase64(file),
            size: file.size
        };
    }
}
